import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-trash" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-pencil" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pi" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-window-maximize" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-exclamation-triangle" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-times" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.userCanEdit === true)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.removeAdDocument())),
          class: _normalizeClass(["removeAdDocument profilMenu", $props.userIsOwner === false ? 'adminSuperPower' : '']),
          "data-cy": "cyRemoveAdDocument"
        }, [
          _hoisted_1,
          _createElementVNode("div", null, _toDisplayString($setup.t("removeAdDocument")), 1)
        ], 2))
      : _createCommentVNode("", true),
    ($props.userCanEdit === true)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.editAdDocument())),
          class: _normalizeClass(["editAdDocument profilMenu", $props.userIsOwner === false ? 'adminSuperPower' : ''])
        }, [
          _hoisted_2,
          _createElementVNode("div", null, _toDisplayString($setup.t("editAdDocument")), 1)
        ], 2))
      : _createCommentVNode("", true),
    (1 === 2 && $props.userCanEdit === true)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.copyAdDocument())),
          class: _normalizeClass(["editAdDocument profilMenu", $props.userIsOwner === false ? 'adminSuperPower' : ''])
        }, [
          _hoisted_3,
          _createElementVNode("div", null, _toDisplayString($setup.t("copyAdDocument")), 1)
        ], 2))
      : _createCommentVNode("", true),
    ($props.displayInModal === true)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.maximizeAdDocument())),
          class: "editAdDocument profilMenu",
          "data-cy": "cyMaximizeAdDocument"
        }, [
          _hoisted_4,
          _createElementVNode("div", null, _toDisplayString($setup.t("maximizeAdDocument")), 1)
        ]))
      : _createCommentVNode("", true),
    ($props.userIsOwner !== true)
      ? (_openBlock(), _createElementBlock("a", {
          key: 4,
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openReportModal($props.aAdDoc))),
          class: "reportAdDocument profilMenu"
        }, [
          _hoisted_5,
          _createElementVNode("div", null, _toDisplayString($setup.t("reportAdDocument")), 1)
        ]))
      : _createCommentVNode("", true),
    ($props.displayInModal === true)
      ? (_openBlock(), _createElementBlock("a", {
          key: 5,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('closeAdDocument'))),
          "data-cy": "cyCloseAdDocument",
          class: "closeAdDocument profilMenu"
        }, [
          _hoisted_6,
          _createElementVNode("div", null, _toDisplayString($setup.t("closeAdDocument")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}